<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">I thank my friends Chris and Jenny Long for their constructive comments and views of my prose and this story and for spending the time to read the book and to study the detailed machinations of the storyline with such dedication.</p><br/>
<p style="text-indent:0em;">My thanks go to Prof David Hughes, Professor of Life Sciences at Oxford University, for his invaluable help with technical life science questions.</p><br/>
<p style="text-indent:0em;">My thanks also to the brilliant actor Anthony Andrews for the inspiration for the character of Sobek and for his and Georgina’s kindness to Patti and me over the years.</p><br/>
<p style="text-indent:0em;">I am indebted to the real Tweedie Brown, and my darling Patti for their inspiration in the creation of the characters in this story.</p><br/>
<p style="text-indent:0em;">Finally, but not least, I thank our son Sebastian whose love of things sci-fi first inspired this book and whose love gives me wings.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?a5310ed4